import { MetricClient, ClientOutput } from '../../Clients/MetricClient';
import { call, put } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/ProjectDashboard/ReviewLifecycleDuration';
import { DatedValue } from '../../../reducers/ProjectDashboard/ReviewLifecycleDuration/Models';

export const metricClient = new MetricClient(new ApiGetter());

interface GetReviewLifecycleDurationAction {
  organizationUUID: string;
  repositoryUUID: string;
}

export const toDates = (
  data: { date: string; value?: number }[] | undefined
): DatedValue[] | undefined =>
  data?.map((d) => {
    return { date: new Date(d.date), value: d.value };
  });

export function* getReviewLifecycleDuration({
  organizationUUID,
  repositoryUUID,
}: GetReviewLifecycleDurationAction) {
  const { data, error }: ClientOutput = yield call(
    [metricClient, metricClient.retrieveAsync],
    {
      organizationUUID,
      repositoryUUID,
      metric: 'average_review_lifecycle_hours',
      period: 30,
    }
  );

  if (error) {
    yield put(actions.setData(undefined));
    return;
  }

  const dateStringsToDates = toDates(data?.byDay);

  yield put(actions.setData(dateStringsToDates));
}
